import { call, takeEvery } from 'redux-saga/effects';
import {
  TRACK_HIT_USAGE_LIMIT,
  TRACK_HIT_PROJECT_DURATION_LIMIT,
  TRACK_HIT_PROJECT_DURATION_LIMIT_MODAL_DISPLAYED,
  TrackHitUsageLimitAction,
  TrackHitProjectDurationLimitAction,
  TrackHitProjectDurationLimitModalDisplayedAction
} from 'js/actionCreators/trackingActions';
import { LIMITS } from 'js/config/consts';

import { track } from '../mixpanelProvider';

const USAGE_LIMIT_EVENT_NAME = {
  [LIMITS.DOWNLOADS]: 'Hit Download Limit',
  [LIMITS.IMAGE_GENERATIONS]: 'Hit Image Gen Limit',
  [LIMITS.VOICEOVER_GENERATION]: 'Hit Voiceover Gen Limit',
  [LIMITS.SCRIPT_GENERATION]: 'Hit Script Gen Limit'
};

function* trackHitUsageLimit({ scribeId, limit }: TrackHitUsageLimitAction) {
  yield call(track, USAGE_LIMIT_EVENT_NAME[limit], { 'Scribe ID': scribeId });
}

function* trackHitProjectDurationLimit({ scribeId }: TrackHitProjectDurationLimitAction) {
  yield call(track, 'Hit Project Duration Limit', { scribeId });
}

function* trackHitProjectDurationLimitModalDisplayed({ scribeId }: TrackHitProjectDurationLimitModalDisplayedAction) {
  yield call(track, 'Hit Project Duration Limit Modal Displayed', { scribeId });
}

export default function* trackLimitsSagas() {
  yield takeEvery(TRACK_HIT_USAGE_LIMIT, trackHitUsageLimit);
  yield takeEvery(TRACK_HIT_PROJECT_DURATION_LIMIT, trackHitProjectDurationLimit);
  yield takeEvery(TRACK_HIT_PROJECT_DURATION_LIMIT_MODAL_DISPLAYED, trackHitProjectDurationLimitModalDisplayed);
}
